<template>
  <div class="bg-white rounded box-shadow p-3">
    <b-modal id="utilities-connection-modal" size="lg" title="Utilities connection" hide-footer>
      <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br/>
        </span>
      </div>
      <div class="modal-content bg-white rounded box-shadow">
        <div class="form-row">
          <div class="col-md-12 col-sm-12 col-lg-12">
            <label for="land_id">Select Land <span class="c-required">*</span></label>
            <select v-model="land.id" v-validate="'required'" id="land_id" name="land_id"
                    class="form-control form-control-sm">
              <option selected :value="''">Select Land</option>
              <option v-for="(land, index) in lands" v-bind:value="land.id" :key="index">Mouza : {{land.mouza.mouza_desc }}, Plot: {{ land.plot_no }}, Land Ownership: {{land.land_ownership_type.land_ownership_type_desc }}</option>
            </select>
            <div class="invalid-feedback">
              Please select valid land
            </div>
          </div>
        </div>

        <div class="form-row mt-2">
          <div class="col-md-12 col-sm-12 col-lg-12">
            <label for="connections">Connections <span class="c-required">*</span></label>
            <multiselect v-model="land.connections" v-validate="'required'" name="connections" id="connections" :multiple="true" :clear-on-select="false" :preserve-search="true" placeholder="Select connection" track-by="id" :options="connections" :custom-label="customConnections"></multiselect>
            <div class="text-danger" style="margin-top: 0.25rem; font-size: 0.75rem;" v-if="errors.has('connections')">Connections is required</div>
          </div>
        </div>

        <div class="form-row mt-3 mb-3">
          <div class="float-right">
            <b-button v-if="!this.btn_edit" class="form-control-sm mr-2" size="sm" variant="success" @click.prevent="save">Add Utilities Connection</b-button>
            <b-button v-if="this.btn_edit" class="form-control-sm mr-2" size="sm" variant="warning" @click.prevent="update">Update Utilities Connection</b-button>
            <b-button size="sm" variant="danger" class="form-control-sm" @click="$bvModal.hide('utilities-connection-modal')">Cancel</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";

export default {
  props: ["land", "btn_edit", "cclShow"],

  components: { Datepicker, Multiselect },
  data() {
    return {
      connections: [],
      lands: [],
      validation_errors: {},
      show: false,
    };
  },
  mounted() {
    this.land.ses_id = this.$route.params.ses_id;
    this.getCodes();
  },
  methods: {
    customConnections(option) {
      return `${option.id} - ${option.connection_desc}`;
    },
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.land.ses_id = this.$route.params.ses_id;
          http
            .post("api/utilities-connections", this.land)
            .then(response => {
              if (!response.data.error) {
                this.$emit("resetForm");
                this.$bvModal.hide("utilities-connection-modal");
                this.$bvToast.toast(response.data.message, {
                  title: "Success",
                  autoHideDelay: 5000,
                  variant: "success"
                });
                this.$emit("getPersonUtilitiesConnections");
              }
              if (response.data.error == true) {
                this.$bvToast.toast(response.data.message, {
                  title: "Error",
                  autoHideDelay: 5000,
                  variant: "danger"
                });
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
            });
        }
      });
    },
    update() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http.put("api/utilities-connections/" + this.land.id, this.land)
            .then(response => {
              if (!response.data.error) {
                this.$bvModal.hide("utilities-connection-modal");
                this.$bvToast.toast(response.data.message, {
                  title: "Success",
                  autoHideDelay: 5000,
                  variant: "success"
                });
                this.$emit("getPersonUtilitiesConnections");
              }
              if (response.data.error == true) {
                this.$bvToast.toast(response.data.message, {
                  title: "Error",
                  autoHideDelay: 5000,
                  variant: "danger"
                });
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
              this.$bvToast.toast("Update Failed", {
                title: "Error",
                autoHideDelay: 5000,
                variant: "danger"
              });
            });
        }
      });
    },
    getCodes() {
      let ses_id = this.$route.params.ses_id;
      http.get("api/utilitiesConnection/codes/" + ses_id).then(response => {
        if (!response.error) {
          let data = response.data;
          this.lands = data.lands;
          this.connections = data.connections;
        }
      });
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
  },
};
</script>
<style>
  .c-required{
    color: red;
  }
</style>
